import React, { useState,useMemo, useEffect } from 'react';
import EcxDatatable from "../../common/datatable/EcxDatatable";
import { useNavigate } from 'react-router-dom';
import ClinicService from '../../../services/clinic.service';
import {toast} from 'react-toastify'
const ClinicDashboard = () => {
    
    const navigate = useNavigate();
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoading(true);
        ClinicService.getAllClinics()
            .then(res => {
                setClinics(res.data);
                setLoading(false);
            })
            .catch(err => {
                setError(true);
                setLoading(false);
                toast.error("Error while getting All Clinics",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })

            });
    }, []);

    const columns =[
        {
            name:'Id',
            selector:row=>row.id,
            sortable:true,
        },
        {
            name:'Type',
            selector:row=>{
                var clinicType = ""
                if(row.clinicType==="EYECONX"){
                    clinicType="Eyeconx"
                }else if (row.clinicType==="SMS_GATEWAY"){
                    clinicType="Sms-Gateway"
                }else if (row.clinicType === "ADMIN"){
                    clinicType="Admin"
                }else{
                    clinicType="Unknown"
                }
                return(
                    <>
                        {clinicType}
                    </>
                )
            },
            sortable:true,
        },
        {   
            name:'Clinic Name',
            selector:row=>{
                const textBackgroundColor = row.status ==="ON"? "badge text-bg-success":"badge text-bg-warning";
               
                return(
                    <>
                        {row.name} - <span className={textBackgroundColor}> {row.status}</span>
                    </>
                )
            },
            sortable:true,
        },
        {   
            name:'Phone',
            selector:row=>row.phone,
            sortable:true,
        },
        {   
            name:'Start Date',
            selector:row=>row.dateStarted,
            sortable:true,
        },
        {
            name:'Options',
            selector:row=>{
                return(
                    <div>

                        <button className="btn btn-primary btn-sm" onClick={()=>handleClick(row.id)}><i className="bi bi-pencil"></i></button>
                       
                    </div>
                )
            },
        }
    ];
   
    const handleClick = (id)=>{
        navigate(`/clinics/${id}`);
    }
    return ( 
        <>

           <section className="section dashboard">
               <div className="row mt-3">
             {  loading?<div className="col-md-12 text-center"><h3>Loading...</h3></div>:
             
             
                <EcxDatatable
                                            columns={columns}
                                            data={clinics}
                                            pagination={true}
                                            paginationPerPage={5}
                                            paginationRowsPerPageOptions={[5, 10, 15]}
                                            highlightOnHover
                                            striped
                                          
                                        />
        }
               </div>
    
           </section>
        </>
     );
}
 
export default ClinicDashboard;